import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Alert, AlertDescription, AlertTitle } from '../ui/alert';
import { CheckCircle2, Info, Loader2, Check } from 'lucide-react';

export function ImportConfirmStep({ validationResult, importing, onBack, onCancel, onConfirm }) {
  if (!validationResult) return null;

  return (
    <div className="space-y-6">
      <div className="text-center">
        <CheckCircle2 className="w-16 h-16 mx-auto text-primary mb-4" />
        <h3 className="text-lg font-semibold mb-2">Conferma Import</h3>
        <p className="text-sm text-muted-foreground">
          Stai per importare gli articoli nel listino materiali
        </p>
      </div>

      <Card className="bg-primary/5 border-primary/20">
        <CardContent className="pt-6">
          <div className="grid grid-cols-2 gap-4 text-center">
            <div>
              <div className="text-3xl font-bold text-emerald-600">{validationResult.new_items}</div>
              <div className="text-sm text-muted-foreground">Nuovi articoli</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-blue-600">{validationResult.update_items}</div>
              <div className="text-sm text-muted-foreground">Articoli aggiornati</div>
            </div>
          </div>
        </CardContent>
      </Card>

      <Alert>
        <Info className="h-4 w-4" />
        <AlertTitle>Operazione irreversibile</AlertTitle>
        <AlertDescription>
          Gli articoli esistenti verranno sovrascritti con i nuovi dati.
          Assicurati che i dati siano corretti prima di procedere.
        </AlertDescription>
      </Alert>

      <div className="flex justify-between">
        <Button variant="outline" onClick={onBack}>
          Indietro
        </Button>
        <div className="flex gap-3">
          <Button variant="outline" onClick={onCancel}>
            Annulla
          </Button>
          <Button
            onClick={onConfirm}
            disabled={importing}
            data-testid="confirm-import-btn"
          >
            {importing ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Importazione...
              </>
            ) : (
              <>
                <Check className="w-4 h-4 mr-2" />
                Conferma Import
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
